<template>
    <div class="cont_fix" v-if="isReady">
        <div class="pop_overlay_black" v-if="isShowAccessDenied">
            <div class="pop_wrap saas_alert">
                <div class="pop_title">
                    <v-icon :size="24">mdi-alert</v-icon>
                    <span>로그아웃 되었습니다.</span>
                </div>
                <div class="pop_cont"><span>다른 PC에서 로그인하여 로그아웃 되었습니다.</span></div>
                <div class="pop_btn"><button class="pop_confirm" @click="action_Logout">확인</button></div>
            </div>
        </div>
        <router-view :key="$route.fullPath"></router-view>
        <MPAlert/>
    </div>
</template>


<script>
const moment = require('@/util/MPMoment')

import { ipcRenderer } from 'electron'
import { mapActions, mapState} from 'vuex'
import MPAlert from '../Main/ShareComponents/Common/MPAlert.vue'
import { TimeSelectModeType, clearSaaSTimeSelectMode, setTimeSelectMode } from '../Main/V2ReservationManagement/reservation-selection'
import { setSelectedDate, setTimezone } from '../Main/V2ReservationManagement/sheet-axis'
import { useQueryClient } from '@tanstack/vue-query'
import { v2HospitalFindQueryOptions } from '@/composables/queries/v2hospital/use-v2-hospital-find-query'
import { v2ServiceSettingFindOneQueryOptions } from '@/composables/queries/v2servicesetting/use-v2-servicesetting-find-one-query'
import { isApiErrorWithCode } from '@/apis/instances/check-api-response'
import { userFindOneQueryOptions } from '@/composables/queries/user/use-user-find-one-query'
import { reservationSheetFindQueryOptions } from '@/composables/queries/reservationsheet/use-reservationsheet-find-query'
import { hserviceFindQueryOptions } from '@/composables/queries/hservice/use-hservice-find-query'

export default {
    components: { MPAlert },
    setup() {
        // 부트스트랩은 순차(await) 흐름이라 useQuery 대신 queryClient.fetchQuery(명령형)를 쓴다
        const queryClient = useQueryClient()
        return { queryClient }
    },
    data() {
        return {
            isLoadServiceSetting: false,
            isLoadLocale: false,
            isLoadTimezone: false,
            
            hospitalID: undefined,
            tempALReservationSheet: undefined
        }
    },
    watch: {
        'remote_notification.d_UserUpdate_el': function() {
            this.loadUserInfo()
        },
    },
    computed: {
        ...mapState(['remote_notification']),
        // 분리 환경 적응: contextIsolation:true라 렌더러에 process.argv가 없음.
        // preload(ipcPreload.js)가 노출한 window.electron.windowName을 사용. (없으면 'Reservation' 폴백)
        window_name() {
            return (typeof window !== 'undefined' && window.electron && window.electron.windowName) || 'Reservation'
        },
        windowName: function() {
            return (typeof window !== 'undefined' && window.electron && window.electron.windowName) || 'Reservation'
        },
        isALReservation: function() {
            return this.hospital.selectedHospital.integrationSetting?.integrationType == "ALM"
                    && this.hospital.selectedHospital.integrationSetting?.isRemoved != true 
                    && this.hospital.selectedHospital.integrationSetting?.usingReservation == true
        },
        isShowAccessDenied: function() {
            return this.remote_notification?.d_Logout_el != undefined
        },
        isReady: function() {
            return this.isLoadServiceSetting && this.isLoadLocale && this.isLoadTimezone
        }
    },
    mounted() {
        this.addListner()
        this.loadInfo()
        this.AC_SetIsWindow(true)
    },
    beforeDestroy() {
        this.removeListener()
    },
    methods: {
        ...mapActions(['AC_SetUser', 'AC_SetIsWindow', 'AC_SetLoginInfo', 'AC_SetHospitalList', 'AC_SetSelectedHospital', 'AC_SetHospitalID', 'AC_ServiceSetting', 'setReservationSheet']),
        loadInfo() {
            ipcRenderer.send('Application.Get.userInfo', {windowName: this.windowName})
        },
        async startLoad(hospitalID) {
            console.log('start load : ', this.$route)
            await this.loadHospital(hospitalID)
            if (this.$route.fullPath == '/w/reservation') {
                await this.moveToReservationSheet()
                ipcRenderer.send('Window.Reservation.targetReservation')
            }
            this.loadServiceSetting()
        },
        async loadHospital(hospitalID) {
            let data
            try {
                data = await this.queryClient.fetchQuery(v2HospitalFindQueryOptions({ _id: hospitalID }))
            } catch (err) {
                // 기존 동작 미러링: 봉투 code != 0 이면 로그 후 중단, 네트워크 등 그 외 예외는 상위로 전파
                if (isApiErrorWithCode(err)) {
                    console.log(err)
                    return
                }
                throw err
            }

            let hospital = data[0]
            this.AC_SetSelectedHospital(hospital)
            this.AC_SetHospitalID(hospital._id)
            const timezone = hospital.timezone

            if (timezone != undefined && timezone != '') {
                this.$store.commit('MU_SetTimezone', timezone)
                setTimezone(timezone)
            }
            this.isLoadTimezone = true
        },
        async loadServiceSetting() {
            let serviceSetting
            try {
                serviceSetting = await this.queryClient.fetchQuery(v2ServiceSettingFindOneQueryOptions({
                    hospitalID: this.hospital.selectedHospital._id
                }))
            } catch (err) {
                // 기존 동작 미러링: 봉투 code != 0 이면 로그 후 중단, 그 외 예외는 상위로 전파
                if (isApiErrorWithCode(err)) {
                    console.log(err)
                    return
                }
                throw err
            }
            this.AC_ServiceSetting(serviceSetting)
            this.isLoadServiceSetting = true
        },
        async loadUserInfo() {
            let userInfo
            try {
                userInfo = await this.queryClient.fetchQuery(userFindOneQueryOptions({ userID: this.user._id }))
            } catch (err) {
                // 기존 동작 미러링: 봉투 code != 0 이면 로그만 남기고 중단
                if (!isApiErrorWithCode(err)) throw err
                console.log(err)
                return
            }
            this.AC_SetUser(userInfo)
        },
        async moveToReservationSheet() {
            let hospital = this.hospital.selectedHospital
            let hospitalID = hospital._id
            if (this.isALReservation == true) {
                // this.$router.push({name: 'ALReservationWindow'})
                // console.log('here')

                let sheets
                try {
                    sheets = await this.queryClient.fetchQuery(reservationSheetFindQueryOptions({hospitalID: hospitalID, isRemoved: false, isIntegrationSheet: true}))
                } catch (err) {
                    // 기존 동작 미러링: 봉투 code != 0 이면 로그만 남기고 중단
                    if (!isApiErrorWithCode(err)) throw err
                    console.log(err)
                    return
                }
                let sheet = sheets[0]
                this.tempALReservationSheet = sheet
                this.setReservationSheet([sheet])
            }
        },
        // MARK: - IPC Handle
        async moveToReservationHandle(_, payload) {
            let reservation = payload.value
            let reservationID = reservation?._id

            if (this.isALReservation) {
                let sheet = this.tempALReservationSheet
                let date = reservation?.selectedDate
                this.$router.push({name: 'ALReservationWindowOnly', query: {sheetID: sheet._id, selectedDate: date}}).catch(() => {})
            }
            else if (reservationID != undefined) {
                // old reservation
                this.$router.push({name: 'Reservation', query: {reservationID: reservationID}}).catch(() => {})
            }
            else {
                // add new reservation
                let hospitalID = this.hospital.selectedHospital._id
                let hserviceID = reservation?.hserviceID
                if (hserviceID == undefined) { return }
                let services
                try {
                    services = await this.queryClient.fetchQuery(hserviceFindQueryOptions({_id: hserviceID, hospitalID: hospitalID}))
                } catch (err) {
                    // 기존 동작 미러링: 봉투 code != 0 이면 로그만 남기고 중단
                    if (!isApiErrorWithCode(err)) throw err
                    console.log(err)
                    return
                }
                clearSaaSTimeSelectMode()
                if (services == undefined || services.length == 0) { return }
                let service = services[0]
                // set date
                setSelectedDate(moment().startOf('days'))
                // set empty reservation
                setTimeSelectMode(service, {}, TimeSelectModeType.fromSaaS)
            }
        },
        async notiHandler(_, payload) {
            // console.log("### ", payload.data.code)

            let receivedAt = moment().format("YYYYMMDD HH:mm:ss.SSS")
            let noti = {
                // title : payload.notification.title,
                // body: payload.notification.body,
                data: payload.data,
                code: payload.data.code, // chat, newUser, newMemo, suspendHService
                sender: payload.data.sender, // sender ID (userID or API)
                isImportant: payload.data.isImportant, // "true" or undefined
                modelName: payload.data.modelName, // DB Name
                modelID: payload.data.modelID,   // DB _id
                chatRoomID: payload.data.chatRoomID, // chatRoomID
                doctorID: payload.data.doctorID, //doctorID
                receivedAt: receivedAt
            }

            
            if (payload.notification != undefined) {
                noti.title = payload.notification.title
                noti.body = payload.notification.body
            }

            this.AC_UpdatePushNotificationValue({
                key: noti.code,
                value: noti
            })

            if (noti.title != undefined && noti.body != undefined) {
                // console.log('noti : ', noti.title, noti.body)
                this.$notify({
                    group: 'notification',
                    title: noti.title,
                    text: noti.body,
                    data: payload
                })
                // 알림 사운드는 SaaS(React) 쪽이 재생한다 — 분리 시 mapState 유실로
                // 이 분기는 이미 동작하지 않았고, notificationsound 모듈 제거와 함께 삭제함
            }
        },
        handleGetUserInfo(_, payload) {
            this.userInfo = payload.value
            this.AC_SetLoginInfo(this.userInfo)
            // 분리 환경 적응: 일렉트론은 같은 origin(app://)이라 로그인 시 저장된 user.token을
            // 예약 창이 localStorage로 공유받지만, 분리된 standalone은 origin이 달라 공유가 안 된다.
            // 따라서 IPC로 받은 userInfo의 token을 user 모듈에 직접 주입해야 API 인증(Bearer)이 동작한다.
            this.AC_SetUser(this.userInfo)

            ipcRenderer.send('Application.Get.locale', { windowName: this.window_name })
            ipcRenderer.send('Application.Get.timezone', { windowName: this.window_name })
            ipcRenderer.send('Application.Get.hospitalID', {windowName: this.windowName})
        },
        handleGetHospitalID(_, payload) {
            this.startLoad(payload.value)
        },
        handleSetHospitalID(_, payload) {
            if (this.isReady == false) {
                return
            }

            this.startLoad(payload.value)
        },
        handleMoveToReservation() {
            ipcRenderer.send('Window.Reservation.targetReservation')
        },
        handleGetLocale(_, payload) {
            // 분리 환경 적응: hospital 로드보다 locale 응답이 먼저 와도 터지지 않도록 옵셔널 체이닝.
            // (selectedHospital이 아직 없으면 locale은 기본값 유지, 단 isReady는 진행시킴)
            const hospitalID = this.hospital.selectedHospital?._id
            const locale = hospitalID != undefined ? payload.value[hospitalID] : undefined
            if (locale != undefined && locale != '') {
                this.$store.commit('MU_SetLocale', locale)
            }
            this.isLoadLocale = true
        },
        addListner() {
            ipcRenderer.on('Application.Get.userInfo',this.handleGetUserInfo)
            ipcRenderer.on('Application.Get.hospitalID', this.handleGetHospitalID)
            ipcRenderer.on('Application.Set.hospitalID', this.handleSetHospitalID)
            ipcRenderer.on('Application.receiveNotification', this.notiHandler)
            ipcRenderer.on('Window.Reservation.moveToReservation', this.handleMoveToReservation)
            ipcRenderer.on('Window.Reservation.targetReservation', this.moveToReservationHandle)
            ipcRenderer.on('Application.Get.locale', this.handleGetLocale)
        },
        removeListener() {
            ipcRenderer.removeListener('Application.Get.userInfo',this.handleGetUserInfo)
            ipcRenderer.removeListener('Application.Get.hospitalID', this.handleGetHospitalID)
            ipcRenderer.removeListener('Application.Set.hospitalID', this.handleSetHospitalID)
            ipcRenderer.removeListener('Application.receiveNotification', this.notiHandler)
            ipcRenderer.removeListener('Window.Reservation.moveToReservation', this.handleMoveToReservation)
            ipcRenderer.removeListener('Window.Reservation.targetReservation', this.moveToReservationHandle)
            ipcRenderer.removeListener('Application.Get.locale', this.handleGetLocale)
        },


        // MARK: - Actions
        action_Logout() {
            ipcRenderer.send('Application.logout')
        }
    }
}
</script>